import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import TextInput from '../common/form/TextInput'
import HowToUseAppGuide from '../reports/HowToUseAppGuide/HowToUseAppGuide'
import AlertDialog from '../common/AlertDialog'
import ValidationModal from '../common/ValidationModal'
import { ReactComponent as LeftArrow } from '../../assets/images/common/icons/left-arrow.svg'


import { isValidEmail } from '../../utility/helperFunctions'
import { inviteFamily as inviteFamilyAction } from '../../actions/familyActions'


const BackButton = () => {
  const navigate = useNavigate()

  return (
    <div
      className='animation-shrink'
      role='button'
      tabIndex={0}
      onClick={() => navigate(-1)}
      onKeyDown={null}
    >
      <LeftArrow color='black' />
    </div>
  )
}

const InviteFamiliesPage = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const alertDialogRef = useRef()
  const currentUser = useSelector(state => state.user.current_user)

  const [isInvitePending, setIsInvitePending] = useState(false)
  const [inviteFormData, setInviteFormData] = useState({ email: '', first_name: '', last_name: '' })
  const [validationState, setValidationState] = useState(
    { showValidationModal: false, validationSuccess: false, validationMessage: '' }
  )

  const inviteFamily = () => {
    const { email, first_name, last_name } = inviteFormData
    const url = window.location.origin

    if (
      email !== '' &&
      first_name !== '' &&
      last_name !== '' &&
      isValidEmail(email)
    ) {
      setIsInvitePending(true)

      dispatch(
        inviteFamilyAction(
          { email, first_name, last_name },
          currentUser.communities[0].id,
          currentUser.id,
          url
        )
      ).then(() => {
        setIsInvitePending(false)
        setValidationState({
          showValidationModal: true,
          validationSuccess: true,
          validationMessage:
            'An email invite has been sent to the family!',
        })
      }).catch(() => alertDialogRef.current?.show())
    } else {
      setValidationState({
        showValidationModal: true,
        validationMessage: 'Please enter a valid email to send',
        validationSuccess: false,
      })
    }
  }

  const closeModal = () => navigate(-1)

  const handleInputChange = (e) => {
    e.persist()
    setInviteFormData((formData) => ({
      ...formData,
      [e.target.name]: e.target.value,
    }))
  }

  const isInviteButtonEnabled =
    inviteFormData['email']
    && inviteFormData['first_name']
    && inviteFormData['last_name']
    && isValidEmail(inviteFormData['email'])


  return (
    <>
      <div className='d-flex align-items-center my-4'>
        <BackButton />
        <h5 className='display-8 mb-0 ml-4'>
          Invite Families to your Community
        </h5>
      </div>
      <div className='modal-content'>
        <div className='row my-4'>
          <div className='col'>
            <h2 className='text-center'>
              Send an email to a family to join your community:
            </h2>
          </div>
        </div>
        <div className='row my-4'>
          <div className='col-3' />
          <div className='col-6'>
            <div className='row'>
              <div className='col-6 mx-auto'>
                <label htmlFor='firstName' className='invite-form-label'>First Name</label>
                <TextInput
                  onChange={handleInputChange}
                  name='first_name'
                  id='firstName'
                  className='form-control mx-auto'
                  type='text'
                  placeholder='Insert First Name'
                  error=''
                />
              </div>

              <div className='col-6 mx-auto'>
                <label htmlFor='lastName' className='invite-form-label'>Last Name</label>
                <TextInput
                  onChange={handleInputChange}
                  name='last_name'
                  id='lastName'
                  className='form-control mx-auto'
                  type='text'
                  placeholder='Insert Last Name'
                  error=''
                />
              </div>
            </div>
            <div className='row mt-2'>
              <div className='col-12 mx-auto'>
                <label htmlFor='email' className='invite-form-label'>Email</label>
                <TextInput
                  onChange={handleInputChange}
                  name='email'
                  id='email'
                  className='form-control mx-auto'
                  type='text'
                  placeholder='family@gmail.com'
                  error=''
                />
              </div>
            </div>
            <div className='w-100 d-flex justify-content-center align-items-center mt-5'>
              <button
                className='btn btn-primary'
                onClick={inviteFamily}
                disabled={isInvitePending || !isInviteButtonEnabled}
              >
                <i className='fa fa-envelope' aria-hidden='true' />{' '}
                {isInvitePending ? 'Sending Email...' : 'Send Email'}
              </button>
            </div>
          </div>
          <div className='col-3' />
        </div>

        <div className='row my-5'>
          <div className='col'>
            <h2 className='text-center'>Or share this guide with your families:</h2>
            <HowToUseAppGuide commId={currentUser.communities[0].id} />
          </div>
        </div>

        <AlertDialog
          hideOnOverlayClicked={true}
          ref={alertDialogRef}
          showOverlay={true}
          title='Error'
          type='danger'
        >
            Something went wrong, please try again later.
        </AlertDialog>
      </div>
      <ValidationModal
        {...validationState}
        closeValidationModal={closeModal}
      />
    </>
  )
}

export default InviteFamiliesPage
